import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ExternalCredentialsIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/external-credentials'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'external_credentials_index',
          component: ExternalCredentialsIndex,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
